var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5C7.5 6.6715 8.17 6 9 6C9.8275 6 10.5 6.6715 10.5 7.5C10.5 8.125 10.1175 8.66 9.5725 8.885C9.5725 8.885 9.5725 8.88575 9.57 8.88675C8.9425 9.1515 8.5 9.77425 8.5 10.5C8.5 10.7758 8.7225 11 9 11C9.2425 11 9.4475 10.8243 9.49 10.5925C9.495 10.5675 9.5 10.5375 9.5 10.5C9.5 10.185 9.6925 9.91575 9.9675 9.805C9.97 9.80425 9.97 9.8025 9.97 9.8025C10.8675 9.42325 11.5 8.53575 11.5 7.5C11.5 6.11925 10.38 5 9 5C7.6175 5 6.5 6.11925 6.5 7.5C6.5 7.77575 6.7225 8 7 8C7.275 8 7.5 7.77575 7.5 7.5Z",
    fill: "#4955FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5C9.5 12.224 9.275 12 9 12C8.7225 12 8.5 12.224 8.5 12.5C8.5 12.7758 8.7225 13 9 13C9.275 13 9.5 12.7758 9.5 12.5Z",
    fill: "#4955FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5C7.5 6.6715 8.17 6 9 6C9.8275 6 10.5 6.6715 10.5 7.5C10.5 8.125 10.1175 8.66 9.5725 8.885C9.5725 8.885 9.5725 8.88575 9.57 8.88675C8.9425 9.1515 8.5 9.77425 8.5 10.5C8.5 10.7758 8.7225 11 9 11C9.2425 11 9.4475 10.8243 9.49 10.5925C9.495 10.5675 9.5 10.5375 9.5 10.5C9.5 10.185 9.6925 9.91575 9.9675 9.805C9.97 9.80425 9.97 9.8025 9.97 9.8025C10.8675 9.42325 11.5 8.53575 11.5 7.5C11.5 6.11925 10.38 5 9 5C7.6175 5 6.5 6.11925 6.5 7.5C6.5 7.77575 6.7225 8 7 8C7.275 8 7.5 7.77575 7.5 7.5Z",
    stroke: "#4955FF",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.5C9.5 12.224 9.275 12 9 12C8.7225 12 8.5 12.224 8.5 12.5C8.5 12.7758 8.7225 13 9 13C9.275 13 9.5 12.7758 9.5 12.5Z",
    stroke: "#4955FF",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 15C13.025 15 13.25 15.224 13.25 15.5C13.25 15.776 13.025 16 12.75 16C12.4725 16 12.25 15.776 12.25 15.5C12.25 15.224 12.4725 15 12.75 15ZM14.675 14.6375C14.5825 14.7393 14.4525 14.805 14.305 14.805C14.0275 14.805 13.805 14.5808 13.805 14.305C13.805 14.1668 13.86 14.0415 13.95 13.9508V13.95C15.215 12.6833 16 10.9333 16 9C16 5.13425 12.865 2 9 2C5.1325 2 2 5.13425 2 9C2 12.8658 5.1325 16 9 16C9.275 16 9.5 16.224 9.5 16.5C9.5 16.776 9.275 17 9 17C4.58 17 1 13.4183 1 9C1 4.58175 4.58 1 9 1C13.4175 1 17 4.58175 17 9C17 11.199 16.11 13.1908 14.675 14.6375Z",
    fill: "#4955FF",
    stroke: "#4955FF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelp);
export default __webpack_public_path__ + "react/media/icon-help.632bf7a8b0d603d40765e7390ef9a218.svg";
export { ForwardRef as ReactComponent };